import { useTranslation } from 'react-i18next';
import { IService } from '@clickersphere/core/entities/IService';
import { Button } from '../../Button';
import Loader from '../../Loader';
import { useDeleteServiceConflictModalController } from './useDeleteServiceConflictModalController';

interface IConflictPackage {
  id: string;
  name: string;
}

interface IDeleteServiceConflictModalProps {
  service: IService;
  packages: IConflictPackage[];
}

export default function DeleteServiceConflictModal({
  service,
  packages,
}: IDeleteServiceConflictModalProps) {
  const { t } = useTranslation();
  const { isProcessing, handleConfirm, handleCancel } =
    useDeleteServiceConflictModalController({ service });

  return (
    <div className="flex flex-col gap-4 py-4">
      <p className="text-text-primary text-sm">
        {t('catalog.conflictModal.description', { name: service.name })}
      </p>

      <div className="flex flex-wrap gap-1.5">
        {packages.map((pkg) => (
          <span
            key={pkg.id}
            className="rounded-full bg-red-50 px-3 py-1 text-xs text-red-700 dark:bg-red-900/30 dark:text-red-300"
          >
            {pkg.name}
          </span>
        ))}
      </div>

      <p className="text-text-secondary text-sm">
        {t('catalog.conflictModal.question')}
      </p>

      <div className="flex gap-3">
        <Button color="ghost" disabled={isProcessing} onClick={handleCancel}>
          {t('catalog.conflictModal.actions.cancel')}
        </Button>
        <Button color="danger" disabled={isProcessing} onClick={handleConfirm}>
          {isProcessing ? (
            <Loader className="h-5 w-5" />
          ) : (
            t('catalog.conflictModal.actions.confirm')
          )}
        </Button>
      </div>
    </div>
  );
}
